import Big from "big.js";

/**
 * (E+F+G) ローカルその他数量 = (A+B) x [gRatio_LocalOther]
 * @param {Big} trialAfterCorrection (A)テスト品のトライアル購入数量(補正後)
 * @param {Big} repeat （B）購入者購入数量
 * @param {number} gRatio ローカルその他比率
 * @returns {Big}
 */
export const calcLocalOther = (trialAfterCorrection: Big, repeat: Big, gRatio: number): Big => {
	return trialAfterCorrection.add(repeat).mul(gRatio);
};
